import React from "react";
var __jsx = React.createElement;
import { Analytics } from '@monofe/app-common';
import { injectConfigManifest, injectENV, injectLog, useBrowser, useKVStorage, useTranslationStorage } from '@monofe/util';

function AnalyticsWrapper(props) {
  const browser = useBrowser();
  const translater = useTranslationStorage();
  const storage = useKVStorage();
  const manifest = injectConfigManifest();
  const env = injectENV();
  const logger = injectLog();
  return __jsx(Analytics, {
    pathname: props.router.asPath,
    manifest: manifest,
    language: browser === null || browser === void 0 ? void 0 : browser.language,
    env: env,
    translater: translater,
    storage: storage,
    logger: logger
  });
}

export default AnalyticsWrapper;